/** A tab of the wizard admin Users page, as kept in the page's `tab` search param. */
export enum WizardAdminUsersTab {
	Access = 'access',
	ReviewerTiers = 'reviewer_tiers',
}
